import { useCallback, useMemo, useRef } from "react";
import { NAVIGATION_CHANNEL, UI_EVENT_TYPE } from "./index";
import { useAnalyticsEvents } from "@atlaskit/analytics-next";
import { useUnifiedAnalyticsContext } from "../../providers/unified-analytics-data-provider";

export const UNIFIED_INSTRUMENTATION_SOURCE = 'topNav';

interface MenuStateChangedAttributes {
	itemState: 'expanded' | 'collapsed';
}

interface UnifiedAnalyticsEvents {
	// Switcher expanded or collapsed event via switcher button or navigation actions
	fireMenuStateChanged: (attributes: MenuStateChangedAttributes) => void;
}

export function useUnifiedAnalytics(): UnifiedAnalyticsEvents {
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const { productSwitcher } = useUnifiedAnalyticsContext();

	const baseAttributes = useRef({
		navLayer: 'global',
		navContainer: 'top',
		navVersion: '4',
	});

	const topLevelAttributes = useMemo(() => ({
		actionSubject: 'atlassianSwitcher',
		eventType: 'ui',
		source: 'topNav',
		product: productSwitcher,
		tags: ['navigationExperiences'],
	}), [productSwitcher]);

    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/91979
    const fireMenuStateChanged = useCallback((attributes: MenuStateChangedAttributes) => {
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: UI_EVENT_TYPE,
            action: 'changed',
            actionSubjectId: 'atlassianSwitcherMenuState',
            attributes: {
                ...baseAttributes.current,
                ...attributes,
            },
        }).fire(NAVIGATION_CHANNEL);
    }, [createAnalyticsEvent, baseAttributes, topLevelAttributes]);

	return {
		fireMenuStateChanged,
	};
}
